var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorkTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.36,181.1c-23.68,0-41.15-5.9-51.94-17.55C45.73,153.09,41.56,138.2,43,119.3,45.84,83,75.91,51.11,107.36,51.11S168.79,83,171.7,119.29h0c1.49,18.85-2.65,33.73-12.33,44.2C148.58,175.18,131.08,181.1,107.36,181.1Zm0-123.53C79.09,57.57,52,86.65,49.45,119.8c-1.31,17,2.3,30.27,10.71,39.36,9.51,10.27,25.39,15.48,47.2,15.48s37.75-5.22,47.27-15.52c8.4-9.1,12-22.33,10.63-39.31C162.61,86.66,135.55,57.57,107.36,57.57Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.36,159.71c-19.67,0-35.68-12.84-35.68-28.62s16-28.63,35.68-28.63S143,115.3,143,131.09,127,159.71,107.36,159.71Zm0-50.79c-16.11,0-29.22,10-29.22,22.17s13.11,22.16,29.22,22.16,29.21-9.94,29.21-22.16S123.47,108.92,107.36,108.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.54,141.26a4.2,4.2,0,0,1-4.2-4.2v-12a4.2,4.2,0,0,1,8.39,0v12A4.18,4.18,0,0,1,99.54,141.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.18,141.26a4.19,4.19,0,0,1-4.2-4.2v-12a4.2,4.2,0,0,1,8.39,0v12A4.1,4.1,0,0,1,115.18,141.26Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 89.79,
    cy: 87.11,
    r: 7.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 124.93,
    cy: 87.11,
    r: 7.39
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.19,101.27l-4.65-4.48c17.61-18.29,17.3-37.41,16.27-45.11-8.27.8-22.2,2.86-35.67,16.95l-4.67-4.46c16-16.76,33.09-18.32,41.29-19.07l1.39-.13,2.85-.28.62,2.79C184.7,52.32,189,77.64,166.19,101.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.52,101.27C25.77,77.64,30,52.32,31.09,47.48l.63-2.79,2.84.28L36,45.1c8.2.75,25.27,2.31,41.3,19.07l-4.67,4.46C59.11,54.54,45.17,52.48,36.91,51.68c-1,7.7-1.35,26.82,16.26,45.11Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorkTag);
export default __webpack_public_path__ + "static/media/PorkTag.88ab8dc65c1522cc48ffc170fd79c958.svg";
export { ForwardRef as ReactComponent };